var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.10638,
    height: 40,
    viewBox: "0 0 47.10638 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.41551,23.22984c1.67064-1.82608,1.61014-4.62551-.13828-6.37393L7.88213,1.47158C7.00698,.6057,5.84738,.12886,4.61688,.12886,3.38401,.12886,2.22553,.60833,1.35464,1.47897,.48425,2.34398,.00327,3.49644,.00002,4.72518c-.00338,1.23764,.47772,2.40212,1.355,3.2794l12.13023,12.12071L1.36804,32.25201C.49602,33.11726,.01392,34.27085,.01066,35.50097c-.00326,1.23764,.47772,2.402,1.35437,3.27877,.87001,.86989,2.03049,1.34911,3.26775,1.34911s2.39774-.47922,3.26926-1.35061l15.45196-15.48403,.0615-.06438Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.85101,16.85591L30.45591,1.47158c-.87515-.86588-2.03475-1.34272-3.26525-1.34272-1.23288,0-2.39135,.47947-3.26224,1.35011-.87039,.865-1.35137,2.01747-1.35462,3.24621-.00338,1.23764,.47772,2.40212,1.355,3.2794l12.13023,12.12071-12.1172,12.12672c-.87202,.86525-1.35412,2.01884-1.35738,3.24896-.00326,1.23764,.47772,2.402,1.35437,3.27877,.87001,.86989,2.03049,1.34911,3.26775,1.34911s2.39774-.47922,3.26926-1.35061l15.45196-15.48403,.0615-.06438c1.67064-1.82608,1.61014-4.62551-.13828-6.37393Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDouble);
export default __webpack_public_path__ + "static/media/arrow-double.7e33921242ef73a07ec6c96505186732.svg";
export { ForwardRef as ReactComponent };